<template>
  <div>
    <div class="card-9-53 mx-9 my-7">
      <!-- Header Section -->
      <div class="flex justify-between items-center border-b border-gray-100 px-5 pt-2.5 pb-2.5 m-0">
        <div>
          <h2 class="text-xl roboto-regular text-gray-800">Manajemen Pengumuman</h2>
        </div>
        <div class="flex items-center space-x-2">
          <el-dropdown @command="handleSyncCommand" :hide-on-click="false">
            <el-button 
              type="success" 
              size="small" 
              :loading="syncLoading"
              class="roboto-regular">
              <i class="el-icon-refresh"></i>
              {{ syncLoading ? 'Syncing...' : 'Sync' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="latest">
                <i class="el-icon-download"></i>
                Sync 10 Berita Terbaru
              </el-dropdown-item>
              <el-dropdown-item command="all" divided>
                <i class="el-icon-refresh-left"></i>
                Sync Semua Data (Admin)
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button 
            type="primary" 
            icon="el-icon-plus" 
            size="small" 
            @click="showCreateDialog = true"
            class="roboto-regular">
            Tambah Pengumuman
          </el-button>
        </div>
      </div>

      <!-- Search Section -->
      <div class="flex justify-start items-center border-b border-gray-100 px-5 pt-2.5 pb-2.5 m-0">
        <div class="w-64">
          <el-input 
            class="roboto-mono-200" 
            placeholder="Cari pengumuman..." 
            size="mini" 
            v-model="searchText"
            clearable>
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <div class="ml-3">
          <el-select 
            v-model="filterKategori" 
            placeholder="Semua Kategori" 
            size="mini" 
            clearable
            class="roboto-mono-200">
            <el-option label="Pengumuman" value="PENGUMUMAN"></el-option>
            <el-option label="Pamflet" value="PAMFLET"></el-option>
            <el-option label="Berita" value="BERITA"></el-option>
          </el-select>
        </div>
        <div class="ml-3">
          <el-select 
            v-model="filterAktif" 
            placeholder="Semua Status" 
            size="mini" 
            clearable
            class="roboto-mono-200">
            <el-option label="Aktif" value="true"></el-option>
            <el-option label="Tidak Aktif" value="false"></el-option>
          </el-select>
        </div>
        <div class="flex-grow">
          <div class="flex items-center justify-end space-x-4">
            <!-- Last sync info -->
            <div v-if="lastSyncTime" class="text-xs text-gray-500">
              Terakhir sync: {{ lastSyncTime | formatDateTime }}
            </div>
            <p class="text-sm roboto-mono-300 p-0 m-0">
              {{ totalElements || 0 }} 
              <span class="roboto-light">Pengumuman</span>
            </p>
          </div>
        </div>
      </div>

      <!-- Error Display -->
      <div v-if="get_pengumuman_error" class="mx-5 my-3">
        <el-alert
          :title="get_pengumuman_error"
          type="error"
          show-icon
          :closable="false">
        </el-alert>
      </div>

      <!-- Loading State -->
      <div v-if="get_pengumuman_loading" class="loading-container">
        <div class="loader"></div>
      </div>

      <!-- Data Table -->
      <div v-if="!get_pengumuman_loading">
        <el-table 
          :data="get_pengumuman" 
          style="width: 100%"
          class="roboto-regular"
          :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#606266' }">
          
          <el-table-column label="Gambar" width="100" align="center">
            <template slot-scope="scope">
              <img 
                v-if="scope.row.gambar && getImageUrl(scope.row.gambar)" 
                :src="getImageUrl(scope.row.gambar)" 
                alt="Gambar Pengumuman" 
                class="w-16 h-12 object-cover rounded cursor-pointer"
                @error="handleTableImageError"
                @click="previewImage(scope.row.gambar)">
              <div v-else class="w-16 h-12 bg-gray-200 rounded flex items-center justify-center">
                <i class="el-icon-picture text-gray-400"></i>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="judul" label="Judul" min-width="200">
            <template slot-scope="scope">
              <div class="roboto-regular">{{ scope.row.judul }}</div>
              <div class="text-xs text-gray-500 roboto-light mt-1">
                {{ scope.row.isi | truncate(50) }}
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="kategori" label="Kategori" width="120" align="center">
            <template slot-scope="scope">
              <el-tag 
                :type="getKategoriType(scope.row.kategori)" 
                size="small">
                {{ getKategoriLabel(scope.row.kategori) }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="Tgl. Awal Tayang" width="130" align="center" v-if="showPamfletColumns">
            <template slot-scope="scope">
              <div v-if="scope.row.kategori === 'PAMFLET'" class="roboto-mono-300 text-sm">
                {{ scope.row.tanggal_terbit | formatDate }}
              </div>
              <div v-else class="text-center text-gray-400">-</div>
            </template>
          </el-table-column>

                    <el-table-column label="Link" width="100" align="center" v-if="showPamfletColumns">
            <template slot-scope="scope">
              <div v-if="scope.row.kategori === 'PAMFLET' && scope.row.link">
                <el-button 
                  type="text" 
                  icon="el-icon-link" 
                  size="mini" 
                  @click="openLink(scope.row.link)"
                  title="Buka Link">
                  Link
                </el-button>
              </div>
              <div v-else class="text-center text-gray-400">-</div>
            </template>
          </el-table-column>

          <el-table-column label="Tgl. Akhir Tayang" width="130" align="center" v-if="showPamfletColumns">
            <template slot-scope="scope">
              <div v-if="scope.row.kategori === 'PAMFLET'" class="roboto-mono-300 text-sm">
                {{ scope.row.tanggal_selesai | formatDate }}
              </div>
              <div v-else class="text-center text-gray-400">-</div>
            </template>
          </el-table-column>

          <el-table-column label="Tgl. Publish" width="120" align="center">
            <template slot-scope="scope">
              <div class="roboto-mono-300 text-sm">
                {{ scope.row.publishedDate | formatDate }}
              </div>
            </template>
          </el-table-column>


          <el-table-column label="Status" width="80" align="center">
            <template slot-scope="scope">
              <el-tag 
                :type="scope.row.aktif ? 'success' : 'danger'" 
                size="mini">
                {{ scope.row.aktif ? 'Aktif' : 'Non-Aktif' }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="Posisi" width="90" align="center">
            <template slot-scope="scope">
              <el-tag 
                :type="getPosisiType(scope.row.posisi)" 
                size="mini">
                {{ getPosisiLabel(scope.row.posisi) }}
              </el-tag>
            </template>
          </el-table-column>


          <el-table-column label="Aksi" width="150" align="center">
            <template slot-scope="scope">
              <el-button 
                type="primary" 
                icon="el-icon-edit" 
                size="mini" 
                circle 
                @click="editPengumuman(scope.row)"
                title="Edit">
              </el-button>
              <el-button 
                :type="scope.row.aktif ? 'warning' : 'success'"
                :icon="scope.row.aktif ? 'el-icon-close' : 'el-icon-check'" 
                size="mini" 
                circle 
                @click="toggleStatus(scope.row)"
                :title="scope.row.aktif ? 'Nonaktifkan' : 'Aktifkan'">
              </el-button>
              <el-button 
                type="danger" 
                icon="el-icon-delete" 
                size="mini" 
                circle 
                @click="confirmDelete(scope.row)"
                title="Hapus">
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- Pagination -->
        <div class="flex justify-center mt-4 mb-4">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="get_pagination.currentPage + 1"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="get_pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="get_pagination.totalElements">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- Create/Edit Dialog -->
    <el-dialog 
      :title="isEdit ? 'Edit Pengumuman' : 'Tambah Pengumuman'"
      :visible.sync="showCreateDialog"
      width="900px"
      :close-on-click-modal="false">
      
      <el-form 
        :model="form" 
        :rules="rules" 
        ref="pengumumanForm" 
        label-width="120px"
        class="roboto-regular">
        
        <el-form-item label="Judul" prop="judul">
          <el-input v-model="form.judul" placeholder="Masukkan judul pengumuman"></el-input>
        </el-form-item>

        <el-form-item label="Isi" prop="isi">
          <el-input 
            type="textarea" 
            v-model="form.isi" 
            :rows="4"
            placeholder="Masukkan isi pengumuman">
          </el-input>
        </el-form-item>

        <el-form-item label="Kategori" prop="kategori">
          <el-select v-model="form.kategori" placeholder="Pilih kategori" style="width: 100%">
            <el-option label="Pamflet" value="PAMFLET"></el-option>
            <el-option label="Pengumuman" value="PENGUMUMAN"></el-option>
            <el-option label="Berita" value="BERITA"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Tanggal Terbit" prop="tanggal_terbit">
          <el-date-picker
            v-model="form.tanggal_terbit"
            type="date"
            placeholder="Pilih tanggal terbit"
            style="width: 100%"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="Tanggal Selesai" prop="tanggal_selesai">
          <el-date-picker
            v-model="form.tanggal_selesai"
            type="date"
            placeholder="Pilih tanggal selesai"
            style="width: 100%"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="Pop Up">
          <el-switch
            v-model="form.is_popup"
            active-text="Ya"
            inactive-text="Tidak">
          </el-switch>
          <div class="text-xs text-gray-500 mt-1">
            Mengatur apakah pengumuman ditampilkan sebagai popup (pamflet)
          </div>
        </el-form-item>

        <el-form-item label="Posisi" prop="posisi">
          <el-select v-model="form.posisi" placeholder="Pilih posisi" style="width: 100%">
            <el-option label="Depan" value="DEPAN"></el-option>
            <el-option label="Tengah" value="TENGAH"></el-option>
            <el-option label="Belakang" value="BELAKANG"></el-option>
          </el-select>
          <div class="text-xs text-gray-500 mt-1">
            Posisi tampilan pengumuman di halaman
          </div>
        </el-form-item>

        <el-form-item label="Status">
          <el-switch
            v-model="form.aktif"
            active-text="Aktif"
            inactive-text="Tidak Aktif">
          </el-switch>
        </el-form-item>

        <el-form-item label="Link" v-if="form.kategori === 'PAMFLET'">
          <el-input 
            v-model="form.link" 
            placeholder="Masukkan link eksternal untuk pamflet (opsional)"
            :disabled="form.kategori !== 'PAMFLET'">
          </el-input>
          <div class="text-xs text-gray-500 mt-1">
            Link eksternal yang akan dibuka ketika pamflet diklik (hanya untuk kategori PAMFLET)
          </div>
        </el-form-item>

        <el-form-item label="Gambar">
          <!-- Image Mode Toggle -->
          <div class="mb-3">
            <el-radio-group v-model="imageMode" size="small">
              <el-radio-button label="upload">Upload File</el-radio-button>
              <el-radio-button label="url">URL Gambar</el-radio-button>
            </el-radio-group>
          </div>

          <!-- URL Input Mode -->
          <div v-if="imageMode === 'url'">
            <el-input
              v-model="form.gambar_url"
              placeholder="Masukkan URL gambar (contoh: https://example.com/image.jpg atau link Google Drive)"
              @blur="validateImageUrl">
              <template slot="prepend">
                <i class="el-icon-link"></i>
              </template>
            </el-input>
            <div class="text-xs text-gray-500 mt-1">
              Pastikan URL gambar dapat diakses secara publik. Untuk Google Drive, gunakan format: https://drive.google.com/uc?id=FILE_ID
            </div>
            <!-- URL Preview -->
            <div v-if="form.gambar_url && isValidUrl(form.gambar_url)" class="mt-2">
              <div class="text-xs text-gray-600 mb-1">Preview:</div>
              <img 
                :src="form.gambar_url" 
                alt="Preview"
                class="w-32 h-24 object-cover border rounded"
                @error="handleImageError"
                @load="handleImageLoad">
            </div>
          </div>

          <!-- File Upload Mode -->
          <div v-if="imageMode === 'upload'">
            <!-- Show existing image info when editing -->
            <div v-if="isEdit && form.existing_image_url && fileList.length > 0" class="mb-2">
              <el-alert
                title="Gambar Existing"
                type="info"
                :closable="false"
                show-icon>
                <div slot="title">
                  <span class="text-sm">Gambar saat ini akan diganti jika Anda upload file baru</span>
                </div>
              </el-alert>
            </div>
            
            <el-upload
              ref="upload"
              :auto-upload="false"
              :on-change="handleFileChange"
              :on-remove="handleFileRemove"
              :before-upload="beforeUpload"
              :file-list="fileList"
              accept="image/*"
              list-type="picture-card"
              :limit="1">
              <i class="el-icon-plus"></i>
            </el-upload>
            <div class="el-upload__tip" slot="tip">
              File gambar dengan ukuran maksimal 2MB (JPG, PNG, GIF)
            </div>
            <!-- Show current uploaded file preview if exists -->
            <div v-if="uploadedImagePreview && !fileList.length" class="mt-2">
              <div class="text-xs text-gray-600 mb-1">File yang akan diupload:</div>
              <img 
                :src="uploadedImagePreview" 
                alt="Upload Preview"
                class="w-32 h-24 object-cover border rounded">
            </div>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm" class="roboto-regular">Batal</el-button>
        <el-button 
          type="primary" 
          @click="submitForm" 
          :loading="get_pengumuman_loading"
          class="roboto-regular">
          {{ isEdit ? 'Update' : 'Simpan' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    'deviceType': String
  },
  data() {
    return {
      API_BASE_URL: 'https://api-intranet.lan.go.id/api',
      searchText: '',
      filterKategori: '',
      filterAktif: '',
      currentPage: 1,
      pageSize: 10,
      showCreateDialog: false,
      isEdit: false,
      editId: null,
      fileList: [],
      imageMode: 'upload', // 'upload' or 'url'
      uploadedImagePreview: null, // For showing file upload preview
      syncLoading: false, // For sync button loading state
      lastSyncTime: null, // Last sync timestamp
      form: {
        judul: '',
        isi: '',
        kategori: '',
        tanggal_terbit: '',
        tanggal_selesai: '',
        is_popup: false,
        link: '',
        gambar: null,
        gambar_url: '',
        posisi: 'TENGAH',
        aktif: true
      },
      rules: {
        judul: [
          { required: true, message: 'Judul harus diisi', trigger: 'blur' }
        ],
        isi: [
          { required: true, message: 'Isi pengumuman harus diisi', trigger: 'blur' }
        ],
        kategori: [
          { required: true, message: 'Kategori harus dipilih', trigger: 'change' }
        ],
        tanggal_terbit: [
          { required: true, message: 'Tanggal terbit harus diisi', trigger: 'change' }
        ],
        tanggal_selesai: [
          { required: true, message: 'Tanggal selesai harus diisi', trigger: 'change' }
        ],
        posisi: [
          { required: true, message: 'Posisi harus dipilih', trigger: 'change' }
        ]
      }
    }
  },
  filters: {
    truncate: function(text, length) {
      if (!text) return ''
      if (text.length <= length) return text
      return text.substring(0, length) + '...'
    },
    formatDate: function(date) {
      if (!date) return '-'
      const d = new Date(date)
      return d.toLocaleDateString('id-ID')
    },
    formatDateTime: function(date) {
      if (!date) return '-'
      const d = new Date(date)
      return d.toLocaleDateString('id-ID') + ' ' + d.toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit' })
    }
  },
  computed: {
    get_pengumuman() {
      return this.$store.state.pengumuman.pengumuman
    },
    get_pengumuman_loading() {
      return this.$store.state.pengumuman.loading
    },
    get_pengumuman_error() {
      return this.$store.state.pengumuman.error
    },
    get_pagination() {
      return this.$store.state.pengumuman.pagination
    },
    // Remove client-side filtering as we now use server-side
    totalElements() {
      return this.get_pagination.totalElements || 0
    },
    // Show PAMFLET-specific columns only if there are PAMFLET items or PAMFLET filter is active
    showPamfletColumns() {
      // Always show if PAMFLET filter is active
      if (this.filterKategori === 'PAMFLET') {
        return true
      }
      
      // Show if there are PAMFLET items in current data
      return this.get_pengumuman.some(item => item.kategori === 'PAMFLET')
    }
  },
  watch: {
    // Auto set popup when kategori is PAMFLET
    'form.kategori': function(newVal) {
      if (newVal === 'PAMFLET') {
        this.form.is_popup = true
      } else if (newVal === 'BERITA' || newVal === 'PENGUMUMAN') {
        this.form.is_popup = false
        // Clear link field when not PAMFLET
        this.form.link = ''
      }
    },
    // Watch for search text changes
    searchText: {
      handler() {
        this.currentPage = 1
        this.debouncedSearch()
      }
    },
    // Watch for filter changes
    filterKategori() {
      this.currentPage = 1
      this.loadPengumuman()
    },
    filterAktif() {
      this.currentPage = 1
      this.loadPengumuman()
    },
    // Watch for image mode changes to clear opposite field
    imageMode(newMode) {
      if (newMode === 'url') {
        this.form.gambar = null
        this.fileList = []
        this.uploadedImagePreview = null
      } else {
        this.form.gambar_url = ''
      }
    }
  },
  created() {
    this.loadPengumuman()
    // Create debounced search function
    this.debouncedSearch = this.debounce(() => {
      this.loadPengumuman()
    }, 500)
  },
  methods: {
    async loadPengumuman() {
      try {
        const params = {
          page: this.currentPage - 1, // API uses 0-based indexing
          size: this.pageSize,
          search: this.searchText || '',
          kategori: this.filterKategori || '',
          aktif: this.filterAktif || ''
        }
        await this.$store.dispatch('pengumuman/getPengumuman', params)
      } catch (error) {
        this.$message.error('Gagal memuat data pengumuman')
      }
    },
    getPosisiType(posisi) {
      switch (posisi) {
        case 'DEPAN': return 'success'
        case 'TENGAH': return 'warning'
        case 'BELAKANG': return 'info'
        default: return 'info'
      }
    },
    getPosisiLabel(posisi) {
      switch (posisi) {
        case 'DEPAN': return 'Depan'
        case 'TENGAH': return 'Tengah'
        case 'BELAKANG': return 'Belakang'
        default: return '-'
      }
    },
    getKategoriType(kategori) {
      switch (kategori) {
        case 'PAMFLET': return 'danger'
        case 'PENGUMUMAN': return 'warning'
        case 'BERITA': return 'success'
        default: return 'info'
      }
    },
    getKategoriLabel(kategori) {
      switch (kategori) {
        case 'PAMFLET': return 'Pamflet'
        case 'PENGUMUMAN': return 'Pengumuman'
        case 'BERITA': return 'Berita'
        default: return kategori
      }
    },
    openLink(link) {
      if (link) {
        window.open(link, '_blank')
      }
    },
    handleSyncCommand(command) {
      if (command === 'latest') {
        this.syncInformasi('latest')
      } else if (command === 'all') {
        this.syncInformasi('all')
      }
    },
    async syncInformasi(type = 'latest') {
      try {
        this.syncLoading = true
        let result
        
        if (type === 'all') {
          // Admin sync - full sync
          result = await this.$store.dispatch('pengumuman/syncInformasi', { type: 'all' })
        } else {
          // Default - latest news sync
          result = await this.$store.dispatch('pengumuman/syncInformasi', { type: 'latest' })
        }
        
        // Show detailed sync result
        if (result.success !== false) {
          const syncedCount = result.syncedCount || result.newItems || 0
          const skippedCount = result.skippedCount || result.existingItems || 0
          let message = `Sinkronisasi berhasil! `
          
          if (syncedCount > 0) {
            message += `${syncedCount} data baru disinkronkan. `
          }
          if (skippedCount > 0) {
            message += `${skippedCount} data sudah ada (dilewati).`
          }
          if (syncedCount === 0 && skippedCount === 0) {
            message += `Tidak ada data baru untuk disinkronkan.`
          }
          
          this.$message.success(message)
          this.lastSyncTime = new Date()
        } else {
          this.$message.warning(result.message || 'Sinkronisasi selesai dengan peringatan')
        }
        
        // Reload data after sync
        await this.loadPengumuman()
      } catch (error) {
        console.error('Sync error:', error)
        const errorMessage = error.response?.data?.error || error.response?.data?.message || 'Gagal melakukan sinkronisasi data'
        this.$message.error(errorMessage)
      } finally {
        this.syncLoading = false
      }
    },
    async toggleStatus(pengumuman) {
      try {
        // Call API to toggle status
        await this.$store.dispatch('pengumuman/toggleStatus', pengumuman.id)
        this.$message.success(`Status pengumuman berhasil ${pengumuman.aktif ? 'dinonaktifkan' : 'diaktifkan'}`)
        // Reload data
        await this.loadPengumuman()
      } catch (error) {
        this.$message.error('Gagal mengubah status pengumuman')
      }
    },
    editPengumuman(pengumuman) {
      this.isEdit = true
      this.editId = pengumuman.id
      this.form = {
        judul: pengumuman.judul,
        isi: pengumuman.isi,
        kategori: pengumuman.kategori,
        tanggal_terbit: pengumuman.tanggal_terbit,
        tanggal_selesai: pengumuman.tanggal_selesai,
        is_popup: pengumuman.is_popup,
        link: pengumuman.link || '',
        gambar: null,
        gambar_url: '',
        posisi: pengumuman.posisi || 'TENGAH',
        aktif: pengumuman.aktif,
        existing_image_url: pengumuman.gambar
      }
      
      // Reset preview
      this.uploadedImagePreview = null
      
      // Set existing image if available
      if (pengumuman.gambar) {
        // Check if existing image is a complete URL
        if (this.isValidUrl(pengumuman.gambar)) {
          this.imageMode = 'url'
          this.form.gambar_url = pengumuman.gambar
          this.fileList = []
        } else {
          this.imageMode = 'upload'
          // For file-based images from API, show in fileList with proper URL
          this.fileList = [{
            name: 'Current Image',
            url: this.getImageUrl(pengumuman.gambar),
            uid: Date.now(),
            status: 'success'
          }]
        }
      } else {
        this.imageMode = 'upload'
        this.fileList = []
      }
      
      this.showCreateDialog = true
    },
    confirmDelete(pengumuman) {
      this.$confirm(`Apakah Anda yakin ingin menghapus pengumuman "${pengumuman.judul}"?`, 'Konfirmasi Hapus', {
        confirmButtonText: 'Ya, Hapus',
        cancelButtonText: 'Batal',
        type: 'warning'
      }).then(async () => {
        try {
          await this.$store.dispatch('pengumuman/deletePengumuman', pengumuman.id)
          this.$message.success('Pengumuman berhasil dihapus')
        } catch (error) {
          this.$message.error('Gagal menghapus pengumuman')
        }
      }).catch(() => {
        // User cancelled
      })
    },
    handleFileChange(file, fileList) {
      console.log('File changed:', file)
      this.form.gambar = file.raw
      
      // Create preview URL for the uploaded file
      if (file.raw) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.uploadedImagePreview = e.target.result
        }
        reader.readAsDataURL(file.raw)
        
        // Show success message for file selection
        this.$message.success('File gambar berhasil dipilih')
        
        // If editing and there's an existing image, show replacement message
        if (this.isEdit && this.form.existing_image_url) {
          this.$message.info('Gambar existing akan diganti dengan file baru ini')
        }
      }
      
      // Update fileList to show the upload
      this.fileList = fileList
    },
    handleFileRemove(file, fileList) {
      this.form.gambar = null
      this.uploadedImagePreview = null
      this.fileList = fileList
    },
    beforeUpload(file) {
      // Validate file type
      const isImage = file.type.indexOf('image/') === 0
      if (!isImage) {
        this.$message.error('File harus berupa gambar!')
        return false
      }
      
      // Validate file size (2MB)
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('Ukuran file tidak boleh lebih dari 2MB!')
        return false
      }
      
      return false // Prevent automatic upload
    },
    // Image URL validation methods
    isValidUrl(string) {
      try {
        const url = new URL(string)
        return url.protocol === 'http:' || url.protocol === 'https:'
      } catch (_) {
        return false
      }
    },
    validateImageUrl() {
      if (this.form.gambar_url && !this.isValidUrl(this.form.gambar_url)) {
        this.$message.warning('Format URL tidak valid')
      }
    },
    handleImageError() {
      this.$message.error('Gambar tidak dapat dimuat. Periksa URL gambar.')
    },
    handleImageLoad() {
      this.$message.success('Preview gambar berhasil dimuat')
    },
    // Image URL helper methods
    getImageUrl(imageUrl) {
      if (!imageUrl) return null
      
      // If it's already a complete URL (http/https), return as is
      if (this.isValidUrl(imageUrl)) {
        return imageUrl
      }
      
      // If it's a filename from upload, construct the API URL
      if (imageUrl && !imageUrl.startsWith('http')) {
        return `${this.API_BASE_URL}${imageUrl}`
      }
      
      return imageUrl
    },
    isImageUrl(url) {
      if (!url) return false
      return this.isValidUrl(url) || url.indexOf('/') !== -1
    },
    handleTableImageError(event) {
      // Replace broken image with placeholder
      event.target.style.display = 'none'
      const placeholder = event.target.parentNode.querySelector('.bg-gray-200')
      if (placeholder) {
        placeholder.style.display = 'flex'
      }
    },
    previewImage(imageUrl) {
      if (!imageUrl) return
      
      const fullImageUrl = this.getImageUrl(imageUrl)
      if (fullImageUrl) {
        // Open image in a new tab for preview
        window.open(fullImageUrl, '_blank')
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.loadPengumuman()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadPengumuman()
    },
    resetForm() {
      this.showCreateDialog = false
      this.isEdit = false
      this.editId = null
      this.imageMode = 'upload'
      this.uploadedImagePreview = null
      this.form = {
        judul: '',
        isi: '',
        kategori: '',
        tanggal_terbit: '',
        tanggal_selesai: '',
        is_popup: false,
        link: '',
        gambar: null,
        gambar_url: '',
        posisi: 'TENGAH',
        aktif: true
      }
      this.fileList = []
      if (this.$refs.pengumumanForm) {
        this.$refs.pengumumanForm.resetFields()
      }
    },
    submitForm() {
      this.$refs.pengumumanForm.validate(async (valid) => {
        if (valid) {
          try {
            // Prepare form data based on image mode
            const formData = { ...this.form }
            
            if (this.imageMode === 'url') {
              // Use URL as image source
              formData.gambar = this.form.gambar_url
              formData.gambar_url = undefined // Remove this field from submission
            } else {
              // Use uploaded file or keep existing image
              formData.gambar_url = undefined // Remove this field from submission
              
              // If no new file is uploaded but we're in edit mode with existing image
              if (!this.form.gambar && this.isEdit && this.form.existing_image_url) {
                // Keep existing image if no new file is uploaded
                formData.gambar = this.form.existing_image_url
              }
            }

            console.log('Submitting form data:', formData)

            if (this.isEdit) {
              await this.$store.dispatch('pengumuman/updatePengumuman', {
                id: this.editId,
                pengumumanData: formData
              })
              this.$message.success('Pengumuman berhasil diupdate')
            } else {
              await this.$store.dispatch('pengumuman/createPengumuman', formData)
              this.$message.success('Pengumuman berhasil dibuat')
            }
            this.resetForm()
          } catch (error) {
            console.error('Submit error:', error)
            this.$message.error(this.isEdit ? 'Gagal mengupdate pengumuman' : 'Gagal membuat pengumuman')
          }
        }
      })
    },
    // Debounce function to limit API calls during search
    debounce(func, delay) {
      let timeoutId
      return function (...args) {
        clearTimeout(timeoutId)
        timeoutId = setTimeout(() => func.apply(this, args), delay)
      }
    }
  }
}
</script>

<style scoped>
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.card-9-53 {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>
